var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPreview),expression:"showPreview"}],staticClass:"wraper",on:{"click":_vm.hidePreview}},[_c('img',{style:({ width: _vm.width + 'px' }),attrs:{"src":_vm.src,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }